// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lo6F","content":"styles_content__1qk-0"};